var map = {
	"./nurse.vue": "./src/views/statistic/nurse.vue",
	"./orderList.vue": "./src/views/statistic/orderList.vue",
	"./pregnant.vue": "./src/views/statistic/pregnant.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/statistic sync \\.vue$";